import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formattedViews = video.views >= 10000
    ? `${(video.views / 10000).toFixed(1)}万`
    : video.views.toString();

  return (
    <Link
      to={`/video/${video.id}`}
      className="group block cursor-pointer"
      aria-label={`观看 ${video.title}`}
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 高清视频在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3 flex items-center justify-between">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90">
              <i className="ri-play-fill text-background-50 text-xl"></i>
            </div>
          </div>
        </div>
        <span className="absolute bottom-2 right-2 bg-black/80 text-background-50 text-xs px-2 py-0.5 rounded-md">
          {video.duration}
        </span>
        {video.isHot && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            热门
          </span>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formattedViews}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {video.rating}
          </span>
          <span>{video.date}</span>
        </div>
      </div>
    </Link>
  );
}